import { HTMLAttributes } from 'react';
import { Notification as PanelNotification } from '../../graphql/generated';

import Notification from './Notification';

interface NotificationPanelProps extends HTMLAttributes<HTMLDivElement> {
  notifications: PanelNotification[];
}

const NotificationsPanel = ({ notifications }: NotificationPanelProps): JSX.Element => {
  return (
    <div className="notifications-container">
      {notifications.map((notification) => (
        <Notification notification={notification} key={notification.id} />
      ))}
    </div>
  );
};

export default NotificationsPanel;
